<style scoped lang="scss" type="text/scss">
    .left-panel-container {
        .badge-container {
            margin-top: 1rem;
            display: flex;
            flex-direction: column;
            align-items: center;

            .sample-photo {
                margin: .5rem 0 .5rem;
            }

            .tips {
            }
        }
    }
</style>

<template>
    <div class="left-panel-container">
        <managed-school-selector></managed-school-selector>
        <card class="badge-container">
            <i-single-image-uploader
                    ref="uploader"
                    v-model="uploadImage"
                    :limit-types="['.png', '.jpg', '.svg', '.jpeg']"
                    :limit-size="2 * 1024 * 1024"
                    :circular="true"
                    :src="src"
                    title="校徽"
                    reversed
                    @file-uploaded="fileUploaded"
            >
            </i-single-image-uploader>
            <sample-photo class="sample-photo" center
                          src="//robo-static.oss-cn-qingdao.aliyuncs.com/images/samples/school-badge.jpeg"
                          title="校徽" tip="请与官方校徽保持一致">
            </sample-photo>
            <div class="tips">
                <info-panel class="info-panel" size="small">
                    请在此上传校徽
                </info-panel>
                <info-panel class="info-panel" size="small">
                    图片类型：JPG / SVG / PNG / JPEG
                </info-panel>
                <info-panel class="info-panel" size="small">
                    大小限制：2 MB 以下
                </info-panel>
                <info-panel class="info-panel" size="small">
                    尺寸建议：1500 像素 * 1500 像素
                </info-panel>
            </div>
        </card>
    </div>
</template>

<script>
    import Card from '../../../../../components/card';
    import ISingleImageUploader from '../../../../../components/i-uploader/single-image-uploader';
    import InfoPanel from '../../../../../components/info-panel';
    import ManagedSchoolSelector from '../../../../sub-components/managed-school-selector';
    import _ from 'lodash';
    import SamplePhoto from '../../../../../components/sample-photo/index';

    export default {
        name: '',
        components: {
            Card,
            ISingleImageUploader,
            InfoPanel,
            ManagedSchoolSelector,
            SamplePhoto
        },
        data () {
            return {
                uploadImage: null
            };
        },
        computed: {
            currentManagedSchoolInfo () {
                return this.$store.state.school.currentManagedSchoolInfo;
            },
            currentManagedSchoolId () {
                return this.$store.state.school.currentManagedSchoolId;
            },
            src () {
                return _.get(this.currentManagedSchoolInfo, 'badge.url', null);
            }
        },
        methods: {
            reloadManagedSchoolInfo () {
                this.$store.dispatch('school/loadManagedSchoolInfo').then();
            },
            fileUploaded (fileInfo, _, throwFail) {
                this.$normalRequest('school/updateSchoolBadge', {
                    id: this.currentManagedSchoolId,
                    ...fileInfo
                }, '校徽更新成功').then(_ => {
                    this.reloadManagedSchoolInfo();
                    fileInfo.finish_callback();
                }).catch(_ => {
                    throwFail();
                    fileInfo.finish_callback();
                });
            }
        }
    };
</script>
